export default "__VITE_ASSET__CP1nMJ2i__"